<script>
  import options from './FormInputCombobox.options'
  export default options
</script>

<template>
  <div ref="rootRef" class="kb-form-input-combobox">
    <div class="kb-form-input-combobox__field">
      <input
        type="text"
        role="combobox"
        class="kb-form-input-combobox__input"
        :id="fieldId"
        :aria-label="ariaLabel"
        :placeholder="placeholder"
        aria-autocomplete="list"
        :aria-expanded="isOpen"
        :aria-controls="listboxId"
        :aria-activedescendant="activeDescendantId"
        v-model="query"
        @input="onInput"
        @keydown="onKeydown"
        @focus="open"
      />
      <button
        type="button"
        class="kb-form-input-combobox__button"
        :aria-label="buttonLabel"
        tabindex="-1"
        @click="onToggle"
      >
        <span class="kb-ui-icon kb-ui-icon--ui-spyglass kb-form-input-combobox__icon" aria-hidden="true"></span>
      </button>
    </div>

    <ul
      v-if="isOpen"
      :id="listboxId"
      role="listbox"
      class="kb-form-input-combobox__results"
    >
      <li
        v-for="(opt, i) in filtered"
        :key="opt"
        :id="getOptionId(i)"
        role="option"
        :aria-selected="isActive(i)"
        class="kb-form-input-combobox__item"
        @click="selectOption(opt)"
        @mousemove="setActive(i)"
      >{{ opt }}</li>
    </ul>

    <p
      v-if="hasNoResults"
      role="status"
      class="kb-form-input-combobox__empty"
    >{{ noResultsLabel }}</p>
  </div>
</template>
